var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEyeIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 16,
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0836 6.71358C19.5378 7.30775 19.5378 8.10988 19.0836 8.70308C17.6528 10.5709 14.22 14.4167 10.2123 14.4167C6.20452 14.4167 2.77177 10.5709 1.34098 8.70308C1.11997 8.41859 1 8.06859 1 7.70833C1 7.34808 1.11997 6.99808 1.34098 6.71358C2.77177 4.84579 6.20452 1 10.2123 1C14.22 1 17.6528 4.84579 19.0836 6.71358V6.71358Z",
    stroke: "url(#paint0_linear_1764_5970)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2123 10.5833C11.8001 10.5833 13.0873 9.29607 13.0873 7.70825C13.0873 6.12043 11.8001 4.83325 10.2123 4.83325C8.62446 4.83325 7.33728 6.12043 7.33728 7.70825C7.33728 9.29607 8.62446 10.5833 10.2123 10.5833Z",
    stroke: "url(#paint1_linear_1764_5970)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1764_5970",
    x1: 4.83838,
    y1: 11.6215,
    x2: 14.4487,
    y2: 0.753177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1764_5970",
    x1: 8.5352,
    y1: 9.38534,
    x2: 12.6081,
    y2: 6.03117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A92FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8764FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIcon);
export default __webpack_public_path__ + "static/media/eye_icon.f3a54786436735b2502291f09f9022b7.svg";
export { ForwardRef as ReactComponent };